/**
 * The page sizes the detail page's card lists offer.
 *
 * Kept out of the component file so both the pagination control and the stored-preference
 * validators can share one definition: a remembered page size is only honoured if it is
 * still a size we offer.
 */
export const PER_PAGE_OPTIONS = [10, 25, 50]

export const isPerPageOption = (value: unknown): value is number =>
    typeof value === 'number' && PER_PAGE_OPTIONS.includes(value)
